import { useEffect, useState } from 'react';
import { inspectionDB } from '../data/database.structure';
import { ActionTypeStore } from '../store/inspection/observation/actionTypeStore';
import { PartDimensionModel } from '../data/types';

/**
 * Loads the part dimension (baseline/limit) for a measurement observable item
 * so screens can show the acceptable range BEFORE the user types (#10205).
 * Mirrors the loading in MeasurementWithActionStatus. DISPLAY-ONLY — stored
 * observation values stay RAW.
 */
const usePartDimensionForPath = ({
  path,
  equipmentPartExternalId,
  dimensionTypeName,
}: {
  path: string;
  equipmentPartExternalId?: string;
  dimensionTypeName?: string;
}) => {
  const [partDimension, setPartDimension] = useState<
    PartDimensionModel | undefined
  >(undefined);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!equipmentPartExternalId) {
      return;
    }

    let cancelled = false;

    const loadPartDimension = async () => {
      const observableItem = await inspectionDB.observableItems
        .where('identifier')
        .equals(path)
        .first();

      let dimension: PartDimensionModel | undefined = undefined;
      if (observableItem) {
        dimension = await new ActionTypeStore().getPartDimension({
          equipmentPartId: equipmentPartExternalId,
          observableItemId: observableItem.id,
          dimensionTypeName,
        });
      }

      if (cancelled) return;
      setPartDimension(dimension);
      setIsLoaded(true);
    };

    loadPartDimension();

    return () => {
      cancelled = true;
    };
  }, [path, equipmentPartExternalId, dimensionTypeName]);

  return { partDimension, isLoaded };
};

export default usePartDimensionForPath;
